import React from 'react';

const ChevronIcon = ({ isActive, isDisabled }) => {
  let color = '#646566';
  if (isActive) {
    color = '#206bef';
  }
  if (isDisabled) {
    color = '#cacccf';
  }
  return (
    <svg
      id="l-caret_2-cmpt"
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      style={{ 
        transform: isActive ? `translateY(0px) rotate(180deg)` : 'none',
        transition: 'all 0.2s ease'
      }}
    >
      <path
        id="caret"
        d="M-7.038-14a1.092,1.092,0,0,0-.771,1.865L-.777-5.1a1.1,1.1,0,0,0,1.548,0L7.8-12.135A1.092,1.092,0,0,0,7.033-14Z"
        transform="translate(19 30)"
        fill={color}
      />
      <rect id="caret-frame" width="38" height="38" fill="none"/>
    </svg>

  )
}

export default ChevronIcon;
